import React from "react";

const ReportsSchduler = () => {
  return <div>In Development</div>;
};

export default ReportsSchduler;
